import { useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";

export default function InvestSuccess() {
  const { state } = useLocation();
  const navigate  = useNavigate();

  // If someone lands here directly with no state, bounce them
  useEffect(() => {
    if (!state?.pkg) navigate("/invest", { replace: true });
  }, [state, navigate]);

  if (!state?.pkg) return null;

  const { name, pkg, amount, monthly, ref } = state;

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "100px 6% 60px", position: "relative" }}>

      {/* Ambient glow */}
      <div style={{ position: "fixed", top: "20%", left: "50%", transform: "translateX(-50%)", width: 700, height: 500, background: "radial-gradient(ellipse,rgba(34,197,94,0.08) 0%,transparent 70%)", pointerEvents: "none" }} />

      <div style={{ width: "100%", maxWidth: 520, animation: "fadeUp 0.5s ease both" }}>

        {/* Success icon */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ width: 80, height: 80, borderRadius: "50%", background: "rgba(34,197,94,0.12)", border: "2px solid rgba(34,197,94,0.35)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 36, margin: "0 auto 24px", animation: "fadeUp 0.4s ease 0.1s both" }}>
            ✅
          </div>
          <h1 style={{ fontSize: "clamp(26px,4vw,40px)", fontWeight: 800, letterSpacing: "-1.5px", marginBottom: 10 }}>
            You're in, {name?.split(" ")[0]}!
          </h1>
          <p style={{ fontSize: 15, color: "var(--text2)", lineHeight: 1.65 }}>
            Your <strong style={{ color: "var(--text)" }}>{pkg} Package</strong> investment has been confirmed.
            Welcome to the Kwikie Express partner family.
          </p>
        </div>

        {/* Confirmation card */}
        <div style={{ background: "var(--bg2)", border: "1px solid rgba(34,197,94,0.25)", borderRadius: 20, padding: "28px", marginBottom: 20 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text3)", letterSpacing: "1px", textTransform: "uppercase", marginBottom: 16 }}>Investment Summary</div>

          {[
            { label: "Package",           value: `${pkg} Package` },
            { label: "Amount Invested",   value: `GHS ${Number(amount).toLocaleString()}` },
            { label: "Monthly Returns",   value: `GHS ${Number(monthly).toLocaleString()}/month` },
            { label: "Minimum Term",      value: "6 months" },
            { label: "Reference",         value: ref },
          ].map((row) => (
            <div key={row.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "10px 0", borderBottom: "1px solid var(--border)" }}>
              <span style={{ fontSize: 13, color: "var(--text3)" }}>{row.label}</span>
              <span style={{ fontFamily: row.label === "Reference" ? "var(--font-mono)" : "var(--font-head)", fontWeight: row.label === "Reference" ? 400 : 700, fontSize: row.label === "Reference" ? 11 : 14, color: "var(--text)", textAlign: "right", maxWidth: "60%", wordBreak: "break-all" }}>{row.value}</span>
            </div>
          ))}

          <div style={{ background: "rgba(34,197,94,0.07)", border: "1px solid rgba(34,197,94,0.2)", borderRadius: 10, padding: "14px 16px", marginTop: 16 }}>
            <div style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.6 }}>
              📧 A confirmation email has been sent. Our team will contact you within <strong style={{ color: "var(--text)" }}>24 hours</strong> to finalize your onboarding.
            </div>
          </div>
        </div>

        {/* What's next */}
        <div style={{ background: "var(--bg2)", border: "1px solid var(--border)", borderRadius: 20, padding: "24px", marginBottom: 24 }}>
          <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 16 }}>What happens next?</div>
          {[
            { icon: "📞", text: "Our team calls you within 24 hours to verify and onboard you." },
            { icon: "🏍️", text: "Your bike is assigned and deployed into our active fleet." },
            { icon: "💸", text: "Your first return lands in your account at end of month 1." },
          ].map((step, i) => (
            <div key={i} style={{ display: "flex", gap: 12, alignItems: "flex-start", marginBottom: i < 2 ? 14 : 0 }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: "var(--bg3)", border: "1px solid var(--border)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>{step.icon}</div>
              <div style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.6, paddingTop: 8 }}>{step.text}</div>
            </div>
          ))}
        </div>

        {/* CTA buttons */}
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <Link to="/" style={{ flex: 1, minWidth: 140, textAlign: "center", padding: "13px", background: "var(--accent)", color: "#000", borderRadius: 10, fontFamily: "var(--font-head)", fontWeight: 800, fontSize: 14, textDecoration: "none" }}>
            Back to Home
          </Link>
          <a
            href="https://wa.me/233551234567"
            target="_blank"
            rel="noopener noreferrer"
            style={{ flex: 1, minWidth: 140, textAlign: "center", padding: "13px", background: "transparent", color: "var(--text)", borderRadius: 10, fontFamily: "var(--font-head)", fontWeight: 700, fontSize: 14, textDecoration: "none", border: "1px solid var(--border)", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            WhatsApp Us
          </a>
        </div>

        <p style={{ textAlign: "center", fontSize: 12, color: "var(--text3)", marginTop: 20 }}>
          Questions?{" "}
          <a href="https://wa.me/233551234567" target="_blank" rel="noopener noreferrer" style={{ color: "#25D366", fontWeight: 600 }}>
            Chat on WhatsApp
          </a>{" "}· visit{" "}
          <a href="https://www.kwikiedelivery.com" style={{ color: "var(--accent)" }}>kwikiedelivery.com</a>
        </p>
      </div>
    </div>
  );
}